import { lazy } from 'react';
export var TeamPageAsync = lazy(function () { return import('./TeamPage'); });
